"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVideoTexture = void 0;
const react_1 = __importStar(require("react"));
const remotion_1 = require("remotion");
let warned = false;
const warnAboutRequestVideoFrameCallback = () => {
    if (warned) {
        return false;
    }
    warned = true;
    // eslint-disable-next-line no-console
    console.warn('Browser does not support requestVideoFrameCallback. Cannot display video.');
};
/*
 * @description Allows you to use a video in React Three Fiber that is synchronized with Remotion's useCurrentFrame().
 * @see [Documentation](https://www.remotion.dev/docs/use-video-texture)
 */
const useVideoTexture = (videoRef) => {
    const { delayRender, continueRender } = (0, remotion_1.useDelayRender)();
    const [loaded] = (0, react_1.useState)(() => {
        if (typeof document === 'undefined') {
            return 0;
        }
        return delayRender(`Waiting for texture in useVideoTexture() to be loaded`);
    });
    const [videoTexture, setVideoTexture] = (0, react_1.useState)(null);
    const [vidText] = (0, react_1.useState)(() => Promise.resolve().then(() => __importStar(require('three/src/textures/VideoTexture.js'))));
    const frame = (0, remotion_1.useCurrentFrame)();
    const onReady = (0, react_1.useCallback)(() => {
        vidText
            .then(({ VideoTexture }) => {
            if (!videoRef.current) {
                throw new Error('Video not ready');
            }
            const vt = new VideoTexture(videoRef.current);
            videoRef.current.width = videoRef.current.videoWidth;
            videoRef.current.height = videoRef.current.videoHeight;
            setVideoTexture(vt);
            continueRender(loaded);
        })
            .catch((err) => {
            (0, remotion_1.cancelRender)(err);
        });
    }, [loaded, vidText, videoRef, continueRender]);
    react_1.default.useLayoutEffect(() => {
        if (!videoRef.current) {
            return;
        }
        if (videoRef.current.readyState >= 2) {
            onReady();
            return;
        }
        videoRef.current.addEventListener('loadeddata', () => {
            onReady();
        }, { once: true });
    }, [loaded, onReady, videoRef]);
    react_1.default.useEffect(() => {
        const { current } = videoRef;
        if (!current) {
            return;
        }
        if (!current.requestVideoFrameCallback) {
            warnAboutRequestVideoFrameCallback();
            return;
        }
        const ready = () => {
            // Now force a new render so the latest video frame shows up in the canvas
            // Allow remotion to continue
        };
        current.requestVideoFrameCallback(ready);
    }, [frame, loaded, videoRef]);
    (0, react_1.useEffect)(() => {
        // Clean up on unmount
        return () => {
            continueRender(loaded);
        };
    }, [loaded, continueRender]);
    if (typeof HTMLVideoElement === 'undefined' ||
        !HTMLVideoElement.prototype.requestVideoFrameCallback) {
        continueRender(loaded);
        return null;
    }
    return videoTexture;
};
exports.useVideoTexture = useVideoTexture;
